var map = {
	"./accessDbInfo.js": "1e95",
	"./accountingCardPagination.js": "197f",
	"./accountingReport.js": "a64d",
	"./activityLog.js": "0e19",
	"./attachedDocuments.js": "0e46",
	"./auxiliarytable.js": "29fe",
	"./bank.js": "898f",
	"./bankReport.js": "37d7",
	"./bookkeeping_banks.js": "191b",
	"./calendar.js": "47fa",
	"./contact.js": "e220",
	"./creditInvoice.js": "0db3",
	"./creditInvoiceReport.js": "08ea",
	"./customer.js": "bbf0",
	"./customerPrice.js": "5c3b",
	"./customerReport.js": "59d0",
	"./dbQuery.js": "d4c38",
	"./debitReport.js": "4458",
	"./delivery.js": "6576",
	"./deliveryReport.js": "5a8e",
	"./deposit.js": "a114",
	"./depositReport.js": "da3d",
	"./documentSeries.js": "79bf",
	"./employee.js": "cd25",
	"./employeeReport.js": "6a7d",
	"./expenses.js": "2191",
	"./funds.js": "b4dc",
	"./generalEvaluation.js": "fdb6",
	"./income.js": "2507",
	"./index.js": "184b",
	"./invoice.js": "8210",
	"./invoiceReport.js": "8ae7",
	"./journalEntry.js": "b1c5",
	"./journalEntryReport.js": "b5ba",
	"./media.js": "f87c",
	"./miscellaneous.js": "3da4",
	"./multiple.js": "1920",
	"./order.js": "d0db",
	"./orderReport.js": "71d3",
	"./other.js": "31ab",
	"./pdfTemplate.js": "b9ce",
	"./periodClosure.js": "163f",
	"./personalMenu.js": "3f56",
	"./priceList.js": "58a1",
	"./product.js": "d1d4",
	"./productReport.js": "cea1",
	"./profile.js": "2f53",
	"./proforma.js": "df53",
	"./proformaReport.js": "7af8",
	"./purchaseOrder.js": "3906",
	"./purchaseOrderReport.js": "9a22",
	"./purchaseReport.js": "4231",
	"./quotation.js": "ca91",
	"./quotationReport.js": "81ae",
	"./receipt.js": "faa6",
	"./receiptReport.js": "148a",
	"./receiptTaxInvoice.js": "f8d3",
	"./receiptTaxInvoiceReport.js": "3d6d",
	"./remarks.js": "3a9f",
	"./returnCertificate.js": "3de3",
	"./returnCertificateReport.js": "828a",
	"./salesReport.js": "d539",
	"./supplier.js": "e136",
	"./supplierCreditInvoice.js": "cbc0",
	"./supplierCreditInvoiceReport.js": "365b",
	"./supplierDebts.js": "58dc",
	"./supplierDeliveryNote.js": "664e",
	"./supplierDeliveryNoteReport.js": "beb5",
	"./supplierInvoice.js": "6e4f",
	"./supplierInvoiceReport.js": "480f",
	"./supplierPayment.js": "0bde",
	"./supplierPaymentReport.js": "b6ec",
	"./supplierPrice.js": "7a94",
	"./supplierReport.js": "3aaf",
	"./trialBalance.js": "61a4",
	"./trialBalancePagination.js": "4242",
	"./updateModule.js": "e6ad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79d3";